export default __webpack_public_path__ + "static/facebook-0fcd880444b7d577791dfb76129d5942.png";